'use strict';

export default {
    threads: []
};
